import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Public pages
import LandingPage from '@pages/LandingPage';
import PrivacyPolicyPage from '@pages/PrivacyPolicyPage';
import DeleteAccountPage from '@pages/DeleteAccountPage';
import UserProfileRedirectPage from '@pages/UserProfileRedirectPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/deleteaccount" element={<DeleteAccountPage />} />
        {/* Deep link redirect: opened by native camera or shared QR link */}
        <Route path="/user/:userId" element={<UserProfileRedirectPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
